import { Mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import { DefaultPageLayout } from 'modules/page';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import RequestCardSkeleton from '../RequestCard/RequestCard.skeleton';

const Content = styled.div`
    min-width: 960px;
    display: flex;
    margin-left: 0;
    width: initial;
`;

const RequestList = styled.div<StyledMods<Mods<'redesign'>>>`
    flex: none;
    width: 33%;
    max-width: 460px;
    height: 100%;
    padding-top: 0;
    padding-left: 40px;
    border-right: 1px solid ${theme.color.midnight50};
    background-color: ${theme.color.white100};
`;

const RequestListItem = styled.div`
    padding: 10px 20px 0;
`;

const RequestListItemCard = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 10px 20px;
    min-height: 93px;
    background: #fff;
`;

const PageSkeleton = () => {
    return (
        <DefaultPageLayout documentTitle='Requests list'>
            <Content>
                <RequestList>
                    {new Array(4).fill(0).map((_, i) => (
                        <RequestListItem key={i}>
                            <RequestListItemCard>
                                <Skeleton height={40} width={40} borderRadius={40} />

                                <div>
                                    <Skeleton height={10} width={30} />

                                    <Skeleton height={10} width={100} />

                                    <Skeleton height={7} width={80} />

                                    <Skeleton height={6} width={100} />
                                </div>

                                <div style={{ alignSelf: 'start', marginLeft: 'auto' }}>
                                    <Skeleton height={20} width={67} />
                                </div>
                            </RequestListItemCard>
                        </RequestListItem>
                    ))}
                </RequestList>

                <RequestCardSkeleton />
            </Content>
        </DefaultPageLayout>
    );
};

export default memo(PageSkeleton);
